import React from 'react';
import { Text, useThemeName } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { Shield } from 'lucide-react-native';

export type VerificationStatusItemProps = {
  title: string;
  subtitle: string;
  actionLabel?: string;
  actionBackgroundColor?: string;
  actionTextColor?: string;
};

const VerificationStatusItem: React.FC<VerificationStatusItemProps> = ({
  title,
  subtitle,
  actionLabel,
  actionBackgroundColor,
  actionTextColor,
}) => {
  const themeName = useThemeName();
  const iconColor = themeName === 'dark' ? '#d4d4d8' : '#71717a';
  const titleColor = themeName === 'dark' ? '#ffffff' : '#18181b';
  const subtitleColor = themeName === 'dark' ? '#a1a1aa' : '#71717a';
  const softBorder = themeName === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)';

  return (
    <YStack
      backgroundColor="$gray2"
      borderRadius="$4"
      padding="$3"
      borderWidth={1}
      borderColor={softBorder}
    >
      <XStack alignItems="center" paddingVertical={8}>
        <YStack
          width={40}
          height={40}
          borderRadius="$2"
          backgroundColor="$gray4"
          borderWidth={1}
          borderColor={softBorder}
          alignItems="center"
          justifyContent="center"
        >
          <Shield size={20} color={iconColor} />
        </YStack>

        <YStack flex={1} marginLeft={12}>
          <Text fontSize="$4" fontWeight="500" color={titleColor}>
            {title}
          </Text>
          <Text fontSize="$3" color={subtitleColor} marginTop="$1">
            {subtitle}
          </Text>
        </YStack>

        {actionLabel && (
          <YStack
            backgroundColor={actionBackgroundColor}
            paddingHorizontal="$3"
            paddingVertical="$1"
            borderRadius="$3"
          >
            <Text fontSize="$2" fontWeight="500" color={actionTextColor}>
              {actionLabel}
            </Text>
          </YStack>
        )}
      </XStack>
    </YStack>
  );
};

export default VerificationStatusItem;
